const XLSX = require('@sheet/core')
const format = require('date-fns/format')
const endOfDay = require('date-fns/end_of_day')
const orderBy = require('lodash/orderBy')
const { ORDER_STATUS_LABELS } = require('../../constants')
const { getOrderStatus } = require('../../tools/get-order-status')
const { getCurrencyForLocation } = require('../../../tools/currency')

const SHEET_NAME = 'Orders'

const BASE_HEADERS = [
  'Order created date',
  'Order id',
  'Payer source',
  'Number of Items Ordered',
  'Order status'
]

exports.getFacilityOrdersExport = getFacilityOrdersExport
async function getFacilityOrdersExport (state, mainApi, params = {}) {
  const { facilityId, programId, startDate, endDate } = params
  if (!facilityId) throw new Error('facilityId is required')
  if (!programId) throw new Error('programId is required')
  if (!startDate) throw new Error('startDate is required')
  if (!endDate) throw new Error('endDate is required')

  const [location, openResult, closedResult] = await Promise.all([
    mainApi.location.get(facilityId, endDate),
    mainApi.order.listFacilityOpenOrdersPG({ parentLocationId: facilityId, programId }),
    mainApi.order.listFacilityClosedOrdersPG({ parentLocationId: facilityId, programId })
  ])

  const startTs = new Date(startDate).getTime()
  const endTs = endOfDay(endDate).getTime()

  const orders = [...(openResult.orders || []), ...(closedResult.orders || [])]
    .filter(order => {
      const submitted = new Date(order.submittedAt).getTime()
      return submitted >= startTs && submitted <= endTs
    })

  if (orders.length === 0) return null

  return buildWorkbook({ orders, location, startDate, endDate })
}

exports.buildWorkbook = buildWorkbook
function buildWorkbook ({ orders, location, startDate, endDate }) {
  const sortedOrders = orderBy(orders, ['submittedAt'], ['desc'])

  const facilityName = (location && location.name) || ''
  const timeframe = `${formatHeaderDate(startDate)} - ${formatHeaderDate(endDate)}`
  const currency = getCurrencyForLocation(location)
  const headers = [...BASE_HEADERS, `Order value (${currency.symbol})`]

  const aoa = [
    ['', `Facility Name: ${facilityName}`],
    ['', `Timeframe: ${timeframe}`],
    headers,
    ...sortedOrders.map(orderToRow)
  ]

  const ws = XLSX.utils.aoa_to_sheet(aoa)

  ws['B1'].s = { bold: true, sz: 12 }
  ws['B2'].s = { bold: true, sz: 12 }
  XLSX.utils.sheet_set_range_style(ws, `A3:${columnLetter(headers.length - 1)}3`, {
    bold: true,
    sz: 12
  })

  ws['!cols'] = [
    { wpx: 140 },
    { wpx: 160 },
    { wpx: 180 },
    { wpx: 180 },
    { wpx: 140 },
    { wpx: 160 }
  ]

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME)

  return XLSX.write(wb, {
    bookType: 'xlsx',
    cellStyles: true,
    type: 'buffer'
  })
}

function orderToRow (order) {
  return [
    format(new Date(order.submittedAt), 'DD/MM/YYYY'),
    order.groupId,
    order.payerOrganisationName || '',
    Object.keys(order.products || {}).length,
    ORDER_STATUS_LABELS[getOrderStatus(order)],
    formatMoney(order.totalAmount)
  ]
}

function formatMoney (value) {
  const amount = Number(value) || 0
  return amount.toLocaleString('en-US')
}

function formatHeaderDate (input) {
  return format(new Date(input), 'DD MMMM YYYY')
}

// A, B, ... Z, AA, AB, ...
function columnLetter (index) {
  let n = index
  let s = ''
  while (n >= 0) {
    s = String.fromCharCode((n % 26) + 65) + s
    n = Math.floor(n / 26) - 1
  }
  return s
}
